var React = require('react');

function IconApplication (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M490.9 730.7c0 108.6-87.9 196.6-196.3 196.6s-196.3-88-196.3-196.6 87.9-196.6 196.3-196.6H490.8v196.6h.1zm43.6 0c0 108.6 87.9 196.6 196.3 196.6S927 839.3 927 730.7s-87.9-196.6-196.3-196.6H534.5v196.6zm-43.6-436.9c0-108.6-87.9-196.6-196.3-196.6s-196.3 88-196.3 196.6 87.9 196.6 196.3 196.6H490.8V293.8h.1zm43.6 0c0-108.6 87.9-196.6 196.3-196.6S927 185.2 927 293.8s-87.9 196.6-196.3 196.6H534.5V293.8z"}));
}

IconApplication.displayName = "IconApplication";

IconApplication.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconApplication;

IconApplication.default = IconApplication;
